import React from 'react';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { ChannelBoxControls } from '../../../../../../../../../components/channel-box-controls';
import { IconInitiate2 } from '../../../../../../../../../assets/icons/icon-initiate-2';
import { useGateControl } from '../../../../../hooks/use-gate-control';

type GateCommonControlsProps = {
  channel: IDeviceChannel;
};

const GateCommonControls: React.FC<GateCommonControlsProps> = ({ channel }) => {
  const { handlePositionPulse } = useGateControl(channel);

  return (
    <ChannelBoxControls
      kind="normal"
      controls={[
        {
          icon: <IconInitiate2 />,
          handleAction: handlePositionPulse,
        },
      ]}
    />
  );
};

export default GateCommonControls;
